<template>
    <div class="container-fluid justify-content-center">

        <channels></channels>

    </div>
</template>

<script>
    import NotificationPop from '../mixins/NotificationPop.js'
    import Channels from "../components/Channels";
    import UpgradeNotification
        from "../mixins/UpgradeNotification";

    export default {
        mixins: [NotificationPop, UpgradeNotification],
        components: { Channels },
        data: () => ({
            // generic
            user: {
            },
            loading: true,
            password: null,
            confirmPassword: null,
        }),
        async created() {

            if ('welcome' in this.$route.query) {
                // Show confetti
                this.$confetti.start({
                    particles: [
                        {
                            type: 'heart',
                            size: 14,
                        }
                    ],
                });
                setTimeout(() => this.$confetti.stop(), 2000);
            }
        }
    }
</script>
